export enum FiboType {
  Dual,
  Quad,
}

export interface Label {
  leftIconId: string;
  leftText: string;
  centerText: string;
  rightText: string;
  rightIconId: string;
  centerIconId: string;
  labelType: LabelOption;
}

export interface Fibonacci {
  id: string;
  description: string;
  type: FiboType;
  amount: number;
  finish: Finish;
  label: Label[];
}

export enum Finish {
  BrushedAluminium = 1,
  BrushedDarkGrey = 2,
  BrushedBlack = 3,
  SatinWhite = 4,
  Bronze = 5,
  FerForgéGrey = 6,
  BrushedNickel = 7,
  BrushedBrass = 8,
  FerForgéGunmetal = 17,
  FerForgéBronze = 18,
  FerForgéRosé = 19,
  Rosé = 21,
  BrushedVolcanicGrey = 22,
}

export enum LabelOption {
  UNDEFINED = -1,
  ARROWS_CENTER_TEXT = 0,
  SYMBOLS_NO_TEXT,
  ARROWS_SYMBOLS_NO_TEXT,
  ARROWS_SIDE_TEXT,
  SIDE_TEXT,
  ARROWS_CENTER_SYMBOL,

  SYMBOLS_CENTER_TEXT,
}
